import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import CategoryPage from './pages/Category';
import ProductDetails from './pages/ProductDetails';
import Customize from './pages/Customize';
import Faq from './pages/Faq';
import Login from './pages/Login';
import TrackOrder from './pages/TrackOrder';
import ClientDetails from './pages/ClientDetails';
import SmartSizeWizardWrapper from './components/SmartSizeWizardWrapper';
import RequestRemake from './pages/RequestRemake';
import ReturnPolicy from './pages/ReturnPolicy';
import ReturnInstructions from './pages/ReturnInstructions';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Appointment from './pages/Appointment';
import EGiftCard from './pages/EGiftCard';
import PerfectFitGuarantee from './pages/PerfectFitGuarantee ';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import Checkout from './pages/Checkout';
import ShippingDelivery from './pages/ShippingDelivery';
import OrderDetails from './pages/OrderDetails';
import PastOrders from './pages/PastOrders';
import Wishlist from './pages/Wishlist';
import Cart from './pages/Cart';
import AboutUs from './pages/AboutUs';
import HelpCenter from './pages/HelpCenter';
import HelpArticle from './pages/HelpArticle';
import SearchResults from './pages/SearchResults';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/category/:slug" element={<CategoryPage />} />
        <Route path="/product/:id" element={<ProductDetails />} />
        <Route path="/customize/:id" element={<Customize />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/login" element={<Login />} />
        <Route path="/track-order" element={<TrackOrder />} />
        <Route path="/ClientDetails/:userId" element={<ClientDetails />} />
        <Route path="/smartSizes/new/:userId" element={<SmartSizeWizardWrapper />} />
        <Route path="/smartSizes/edit/:userId" element={<SmartSizeWizardWrapper />} />
        <Route path="/request-remake" element={<RequestRemake />} />
        <Route path="/return-policy" element={<ReturnPolicy />} />
        <Route path="/return-instructions" element={<ReturnInstructions />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/appointment" element={<Appointment />} />
        <Route path="/egiftcard" element={<EGiftCard />} />
        <Route path="/perfect-fit" element={<PerfectFitGuarantee />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/shipping-delivery" element={<ShippingDelivery />} />
        <Route path="/past-orders" element={<PastOrders />} />
        <Route path="/order/:orderId" element={<OrderDetails />} /> 
        <Route path="/Wishlist" element={<Wishlist />} />
        <Route path="/Cart" element={<Cart />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/createashirt" element={<Customize />} />
        <Route path="/help" element={<HelpCenter />} />
        <Route path="/help/:slug" element={<HelpArticle />} />
        <Route path="/search" element={<SearchResults />} />
      </Routes>
    </Router>
  );
}

export default App;
